import React, { useState,useRef } from "react";
import { Link } from "react-router-dom";
import logo from "static/img/registlogo.png";
import registerIcon from "static/img/registerIcon.png";
import { message} from 'antd';
import "./index.less";
import {loadNetcaJs, request} from "utils.js";
import Online from "components/online";


export default function NoticePage() {
	let redirect = location.hash.split('redirect=')[1] || 'https://aiprt.aipuret.cn/portal-notice/';
	window.os_fe_isLogin = function () {
		return false;
	};
	const iframeRef = useRef(null);
	const [ caShow , setCAShow ] = useState(false)
	

	window.os_fe_loginCallback = function () {
		window.location.href = redirect;
	}
	// CA 登陆-Start
	const caLogin = () => {
		loadNetcaJs(netcaLogin)
	}
	const netcaLogin = async ()=> {
		// 检查驱动
		const params = {};
		NetcaPKI.checkPKIInstall(params)
			.Then(function (res) {
				console.log('链接CA驱动成功：', res);
				checkPasswordNetca();
			})
			.Catch(function (res) {
				if (res.status === NETCA_ERROR_WEBSOCKETCONNECTFAIL) {
					// 连接失败 返回错误 其他错误认为是成功
					console.error('链接CA失败:', res);
					message.error("请确认网证通驱动安装成功！" + res.msg);
					return false;
				} else {
					checkPasswordNetca();
				}
			});
	}
	const checkPasswordNetca = async () => {
		// 密码验证成功，进行登陆逻辑
		fetch("/aiprt-basedata-register-be/netca/loginCaByRandNum")
			.then(res => res.json())
			.then(res => {
				console.log("随机数据",res);
				const {code, message:msg, data} = res;
				if (code !=="200") {
					message.error("请求签名数据异常:" + msg);
					return false;
				}
				// 签名数据
				const params = {
					cert: { //证书(CertificateParams)
						encode: "", //可选字段但不能为空
						type: "{\"UIFlag\":\"default\", \"InValidity\":true,\"Type\":\"signature\", \"Method\":\"device\",\"Value\":\"any\"}",
						condition: "IssuerCN~'NETCA' && InValidity='True' && CertType='Signature'"
					},
					data: { //数据(DataParams)
						text: utf8_to_b64(data)
					},
					useSubjectKeyId: true, //是否使用主体密钥标识符来标识证书，默认为true
					useQ7:false, //布尔值	是否使用国密Q7的方式，默认为false
					detached: 0,
					tsaURL: "",
					includeCertOption: 2//整数	包含证书的标识
				};
				NetcaPKI.signedDataSign(params)
					.Then(function (res) {
						console.log("随机数据加密结果",res);
						const {certObject, signCert, signValue} = res;
						if(res.result === -5 || res === -81) {
							message.error("密码错误，密码重试次数为："+res.retrynum)
							return false;
						}
						// 发送签名数据到后台验证，并进行登陆
						request({
							method: 'post',
							url: "/aiprt-basedata-register-be/netca/loginCaVerify",
							data: {
								"signValue": signValue,
								"certValue":signCert,
								"creditcode":certObject?.netcaEnterpriseidItems[0],
								"extendVerify": "ocspVerfiyCert"
							}
						}).then(r => {
							// 登陆结果
							console.log(r);
							window.location.href = r;
						})
					})
					.Catch(function (e) {
						console.error("签名异常",e)
						message.error("数据签名异常，登陆失败:"+ e.msg);
						return false;
					})
			}).catch(e => {
			message.error('获取签名数据异常:' + e.msg);
			return false;
		})
	}
	const showCA =()=>{
		setCAShow(true)
	}
	const hiddenCA =()=>{
		setCAShow(false)
	}

	// CA 登陆-END
	return (
		<div className="loginBox">
			<div className="loginBox-logo">
				<Link to="/">
					<img src={logo} />
				</Link>
			</div>
			<div className="loginBox-img">
				
			</div>
			<div className="loginBox-con">
				<div className="loginBox-left"><img src={registerIcon} /></div>
				<div className="loginBox-right">
					<div className="loginBox-kuang">
						<div className="iframeSideBox">
							<iframe 
								id="yonbip_login_id"
								title="yonbip_login"
								// src="https://aiprt.aipuret.cn/cas/login?sysid=yonbip&mode=light&casLoginType=normal&service=https://aiprt.aipuret.cn/login_light?yhtdesturl=/yhtssoislogin&yhtrealservice=https://aiprt.aipuret.cn&locale=zh_CN&hideQr=1"
								src={"https://aiprt.aipuret.cn/cas/login?sysid=yonbip&ignoreCycle=1&mode=light&service=https://aiprt.aipuret.cn/login_light?yhtdesturl=/yhtssoislogi&yhtrealservice=" + redirect}
								className="iframe"
							></iframe>
						</div>
						{caShow  ? <div className="loginCA">
							<span className="closeCA" onClick={hiddenCA}>X</span>
							<div>请插入CA后再点击登录</div>
							<a className="caaButton" onClick={caLogin}>CA登录</a>
							<a className="caaButton" href="https://kdocs.cn/l/ceD4DOzBLTzf" target="_blank">CA办理指南</a>
						</div>:''}
						<div className="loginBox-register">
							<a className="caButton" onClick={showCA}>CA 登录</a>
							<Link to="/register">供应商登记</Link>
							<Link to="/agencyRegister">代理机构登记</Link>
							<Link to="/purchaserRegister">采购人登记</Link>
							<Link to="/expertRegister">专家登记</Link>
						</div>
					</div>
				</div>
			</div>
			<div className="register-text">
				<div>版权所有©公共资源数智采平台 </div>
				<div>
					<a href="https://beian.miit.gov.cn/" target="_blank">
						粤ICP备2022095238号
					</a>
				</div>
			</div>
			<Online />
		</div>
	);
}
